import React, {useEffect, useState} from 'react';
import * as EmployerService from "@app/services/EmployerService";
import {Link} from "react-router-dom";

const EmployerGeneral = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [emp, setEmp] = useState({});

    const {employer} = props

    useEffect(() => {
        console.log("fetchCandidateGeneral")
        if (employer) {
            setEmp(employer)
        }
    }, [employer])


    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>General</h3>
                {/*<div className='card-tools'>*/}
                {/*    {isEditGeneral &&*/}
                {/*    <button type='button'*/}
                {/*            className='btn btn-default mr-2'*/}
                {/*            onClick={() => {*/}
                {/*                setIsEditGeneral(false);*/}
                {/*            }}*/}
                {/*            >*/}
                {/*        Cancel*/}
                {/*    </button>*/}
                {/*    }*/}
                {/*    {!isEditGeneral &&*/}
                {/*    <button type='button'*/}
                {/*            className='btn btn-default'*/}
                {/*            onClick={() => {*/}
                {/*                setIsEditGeneral(true);*/}
                {/*            }}*/}
                {/*            >*/}
                {/*        Edit*/}
                {/*    </button>*/}
                {/*    }*/}
                {/*</div>*/}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}>Employer ID: &nbsp;{emp.id}</label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>User
                        chủ: &nbsp;{emp.created_user_email}</label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>Employer Link: &nbsp;
                        <Link to={`/employer/edit/${emp.id}`} target="_blank"
                              rel="noopener noreferrer">{`${window.location.origin}/employer/edit/${emp.id}`}</Link>
                    </label>
                </div>
                <div className='input-group'>
                    <label className={'w-100'}>Thời điểm
                        nhập: &nbsp; {emp.created_date_time}</label>
                </div>
            </div>
        </div>
    )
}

export default EmployerGeneral;
